import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBottom = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.995 13.1625L7.995 2.60001M3.12 8.69376L7.71062 13.2844C7.78656 13.3588 7.88866 13.4005 7.995 13.4005C8.10133 13.4005 8.20343 13.3588 8.27937 13.2844L12.87 8.69376",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgArrowBottom;
